import * as XLSX from 'xlsx'
import { apiConstants, postGeneric } from '../../common/constants'
import { parseDateAndTime } from '../../helpers/UtilityHelper'

// Only the fields we actually export — keeps the response light (projection instead of
// fetching the whole order doc). Field names are the model (camelCase) names; the API
// serializes some as snake_case (awb_number / payment_mode / delivery_details) — see mapping below.
const DOWNLOAD_INCLUDES = "id,awbNumber,reference,shippingLabelId,awbRegisteredDate,courierDetail,orderStatus,ndrData,paymentMode,deliveryDetails,ofdAttemptCount";

// Shared NDR list download (Pending / Initiated / Closed tabs).
// Re-uses the same andfilter/orfilter the tab's grid uses, but pulls the full set
// (not just the current page) and writes an .xlsx of the AWB list.
export async function downloadNdrList({ andfilter = [], orfilter = [], fileName }) {
    const res = await postGeneric(apiConstants.NDR_LISTS, {
        andfilter,
        orfilter,
        offset: 0,
        limit: 5000,
        skipCount: true,
        includes: DOWNLOAD_INCLUDES,
    })
    const rows = res?.data?.data || []
    if (!rows.length) return 0

    const out = rows.map((r) => ({
        'AWB Number': r.awb_number || '',
        'Order / Reference': r.reference || '',
        'Shipping Label ID': r.shippingLabelId || '',
        'AWB Registered Date': r.awbRegisteredDate ? parseDateAndTime(r.awbRegisteredDate) : '',
        'Courier': r.courierDetail?.parent || r.courierDetail?.name || '',
        'Status': (r.orderStatus || '').replace(/_/g, ' '),
        'NDR Status': r.ndrData?.ndrStatus || '',
        'NDR Reason': r.ndrData?.ndrCpStatusDescription || '',
        'NDR Reported Date': r.ndrData?.ndrReportedDate ? parseDateAndTime(r.ndrData.ndrReportedDate, true) : '',
        'NDR Comments': r.ndrData?.remark || '',
        'OFD Attempts': r.ofdAttemptCount != null ? r.ofdAttemptCount : (r.ndrData?.deliveryAttemptCount != null ? r.ndrData.deliveryAttemptCount : ''),
        'Payment Mode': r.payment_mode || '',
        'Customer': r.delivery_details?.to_name || '',
        'City': r.delivery_details?.to_city || '',
        'State': r.delivery_details?.to_state || '',
        'Pincode': r.delivery_details?.to_pincode || '',
    }))

    const ws = XLSX.utils.json_to_sheet(out)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'NDR')
    XLSX.writeFile(wb, fileName)
    return rows.length
}
